<div class="sh-contained-media placeholder-root">
    <div #placeholderImage [ngClass]="message ? 'placeholder-container-free' : 'placeholder-container-block'" [title]="message ? message: ''">
        <img class="sh-contained-media__media placeholder-image" [src]="source" [alt]="alt" draggable="false" />
        <svg class="spinner" viewBox="0 0 50 50" [style]="spinning ? '' : 'display: none'" #spinner>
            <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
        </svg>
    </div>
    <div class="sh-contained-media__media placeholder-message" *ngIf="showMessage">{{ message }}</div>
</div>
